import {
  ADD_COUPON,
  GET_ALL_COUPON,
  DELETE_COUPON,
  GET_ONE_COUPON,
  EDIT_COUPON,
} from "../type";
const inital = {
  addCoupon: [],
  allCoupon: [],
  oneCoupon: [],
  editCoupon: [],
  deleteCoupon: [],
};

const couponReducer = (state = inital, action) => {
  switch (action.type) {
    case ADD_COUPON:
      return {
        ...state,
        addCoupon: action.payload,
      };
    case GET_ALL_COUPON:
      return {
        ...state,
        allCoupon: action.payload,
      };
    case GET_ONE_COUPON:
      return {
        ...state,
        oneCoupon: action.payload,
      };
    case EDIT_COUPON:
      return {
        ...state,
        editCoupon: action.payload,
      };
    case DELETE_COUPON:
      return {
        ...state,
        deleteCoupon: action.payload,
      };

    default:
      return state;
  }
};

export default couponReducer;
